import * as React from 'react';
import { Button } from '@frontend/shadcn/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader } from '@frontend/shadcn/components/ui/dialog';
import { TriangleExclamationIcon } from '@revfluence/fresh-icons/solid/esm';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
}

export const DeleteBoostConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Are you sure you want to delete boost?',
  description = 'Please note that boosts will only be deleted for the members who have not claimed it yet. All the past claimed/waiting for approval boosts will remain unchanged.',
}: DeleteConfirmationModalProps) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[512px] !rounded-2xl bg-grey-0 p-0 gap-0 border-0 shadow-lg">
        <DialogHeader className="flex flex-row items-center justify-start p-6 space-y-0">
          <TriangleExclamationIcon className="text-red-5 w-6 h-6 mr-3" />
          <p className="text-primary text-lg font-medium m-0">{title}</p>
        </DialogHeader>
        <div className="px-6">
          <p className="text-grey-5 text-sm leading-relaxed">{description}</p>
        </div>
        <DialogFooter className="px-6 flex gap-3 justify-end">
          <Button variant="outline" onClick={onClose} className="px-6">
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            className="px-6 bg-red-5 hover:bg-red-6 text-grey-0 border-0"
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteBoostConfirmationModal;
